import React, { useState, useCallback, useMemo } from 'react'

import Box from '@mui/material/Box'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput'
import Chip from '@mui/material/Chip'
import Select from '@mui/material/Select'
import columnsGenerator from './columnsGenerator';

/**
 * accepts available columns, preslected columns, 
 * 
 * returns react data table column headers
 */

const ColumnsSelector = ({
  onColumnsChange = () => { },
  selectedColumns = [],
  columnTemplates = [],
  /** If set, only these defs are used to build table columns; `columnTemplates` drives the menu list. */
  columnTemplatesForTable = null,
}) => {
  const tableTemplates = columnTemplatesForTable ?? columnTemplates

  let onChange = useCallback((e) => {
    const value = e.target.value
    let generatedColumns = columnsGenerator(tableTemplates, value)
    onColumnsChange(generatedColumns, value)
  }, [onColumnsChange, columnTemplates, tableTemplates])

  return <div>
    <FormControl size='small' sx={{ width: 300 }} >
      <Select
        id="demo-multiple-chip"
        multiple
        value={selectedColumns}
        onChange={onChange}
        input={<OutlinedInput id="select-multiple-chip" />}
        renderValue={(selected) => {
          return <Box sx={{ display: 'flex', gap: 0.5, overflow: 'auto' }}>
            {selected.map((selectedColumn) => {
              let column = columnTemplates.find((columnItem) => {
                const k = columnItem.accessorKey ?? columnItem.accessorkey
                return k === selectedColumn
              })

              return <Chip key={selectedColumn} label={column?.header || 'N/A'} />
            })}
          </Box>
        }}
      >
        {columnTemplates.map((template) => {
          const accessorKey = template.accessorKey ?? template.accessorkey
          if (accessorKey == null) return null
          return (
          <MenuItem
            key={accessorKey}
            value={accessorKey}
          >
            {template.header}
          </MenuItem>
        )})}
      </Select>

    </FormControl>
  </div>
}

export default ColumnsSelector